import React, { Fragment } from 'react'
import { useApi } from '../../../hooks/useApi'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { PickingRoute } from '../../../interfaces/Picking/Picking'
import { ModalReturnType } from '../../../hooks/useModal'
import { Modal } from '../../../components/_EOS/Modal'
import { Container, Grid, List, Typography } from '@mui/material'
import { Status } from '../../../hooks/useFetchState'
import { StockBreakDto } from '../../../interfaces/Planner/StockBreak'
import { ListItemIcon } from '../../../components/ListItemIcon/ListItemIcon'
import { t } from '../../../intl/resources'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface CreatePickingRouteModalProps {
  selectedOts: number[]
  createPickingRouteModal: ModalReturnType<PickingRoute>
  handleSnackbarNotification: (msg: string | undefined, status: boolean) => void
  handleRequestWorkOrders: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

interface CreatePickingRouteDto {
  forceZone: boolean
  workOrderIds: number[]
}

export interface CreatePickingRouteResponseDto {
  success: boolean
  codeMessage: number
  message: string
  messageExtra: any
  data: StockBreakDto
}

const postCreatePickingRoute = (dto: CreatePickingRouteDto) => {
  const url = new URL(`${ApiConfig.PickingRouteApi}`)

  return axios.post(url.toString(), dto)
}

export const CreatePickingRouteModal: React.FC<CreatePickingRouteModalProps> =
  ({
    selectedOts,
    createPickingRouteModal,
    handleSnackbarNotification,
    handleRequestWorkOrders
  }) => {
    const [shouldForceZone, setShouldForceZone] = React.useState(false)
    const { state, callApi } = useApi<CreatePickingRouteResponseDto>()

    const requestCreatePickingRoute = () => {
      callApi(
        postCreatePickingRoute({
          forceZone: shouldForceZone,
          workOrderIds: selectedOts
        })
      )
        .then((response: CreatePickingRouteResponseDto) => {
          if (response.success) {
            // significa que creamos la ruta, si que mostramos el mensaje
            handleSnackbarNotification(response.message, true)
            handleRequestWorkOrders()
            createPickingRouteModal.closeModal()
          } else {
            // significa que nos dijo que no hay stock
            // para ciertos elementos
            setShouldForceZone(true)
          }
        })
        // Hubo un error, si que lo desplegamos y cerramos
        // No tiene sentido dejar abierto el modal
        .catch((error) => handleSnackbarNotification(error, false))
    }

    const onCloseModal = () => {
      setShouldForceZone(false)
      createPickingRouteModal.closeModal()
    }

    return (
      <Modal
        open={createPickingRouteModal.isOpen}
        maxWidth={createPickingRouteModal.size}
        onClose={onCloseModal}
        title={createPickingRouteModal.title}
        cancelButton={{
          action: onCloseModal,
          title: t('CANCEL')
        }}
        successButton={{
          action: requestCreatePickingRoute,
          title: t('ACCEPT')
        }}
        loading={state.status === Status.Loading}
      >
        {shouldForceZone ? (
          <Fragment>
            <Container maxWidth='xl'>
              <Typography variant='h4' component='h2' gutterBottom>
                QUIEBRE DE STOCK
              </Typography>

              <Grid
                container
                direction='column'
                spacing={2}
                alignItems='center'
              >
                <Grid item xs={12}>
                  <Typography variant='h6'>
                    No hay suficientes productos para completar la(s) ruta(s)
                  </Typography>
                  <Typography variant='h6'>¿Desea continuar?</Typography>
                </Grid>

                <Grid item xs={12}>
                  {state.data?.data?.listDetail?.map((item) => (
                    <Grid container direction='row' spacing={2}>
                      <Grid item xs={6}>
                        {item.name}
                      </Grid>
                      <Grid item xs={4}>
                        {item.sku}
                      </Grid>
                      <Grid item xs={2}>
                        {` QTY: ${item.qty}`}
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
                <Grid item xs={12}>
                  <List>
                    <ListItemIcon
                      primary={``}
                      secondary={
                        'Si continúa y el producto tiene 0 stock, se asignará el quiebre a una zona por defecto'
                      }
                      icon='info'
                    />
                  </List>
                </Grid>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-evenly',
                    marginBottom: '20px'
                  }}
                >
                  <Typography variant='body1'>
                    Almacén: {state.data?.data?.warehouseName}
                  </Typography>
                  <Typography variant='body1'>
                    Zona: {state.data?.data?.zoneName}
                  </Typography>
                </div>
                {state.data?.data?.zoneName && (
                  <Grid item xs={12}>
                    <Typography variant='h6'>
                      Si desea cambiar la zona predeterminada, lo puede realizar
                      editando el almacén
                    </Typography>
                  </Grid>
                )}
                {!state.data?.data?.zoneName && (
                  <Grid item xs={12}>
                    <Typography variant='h6'>
                      Debe configurar una zona pre determinada en la
                      configuración del almacén{' '}
                      {state.data?.data?.warehouseName},{' '}
                      <a
                        onClick={() => {}}
                        style={{ color: 'blue', cursor: 'pointer' }}
                      >
                        Favor aprete aquí
                      </a>
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Container>
          </Fragment>
        ) : (
          <Typography variant='body2'>
            ¿Desea crear ruta picking para orden de trabajo seleccionados?
          </Typography>
        )}
      </Modal>
    )
  }
